import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  loading: false,
  data: [],
  error: "",
};

export const getSurveyInfo = createAsyncThunk(
  "getSurveyInfo",
  async (params, { rejectWithValue }) => {
    try {
      const token = params?.token;
      const surveyId = params?.surveyId;
      // const sectionId = params?.sectionId;
      // const questionId = params?.questionId;

      const urls = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_PREFIX_URL}${surveyId}/surveyInfo/`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(urls, { headers });
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const getSurveyInfoSlice = createSlice({
  name: "getSurveyInfos",
  initialState,
  reducers: {
    clearData(state) {
      state.data = [];
      state.error = "";
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSurveyInfo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSurveyInfo.fulfilled, (state, action) => {
      console.log("Get single Question data:", action.payload);
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(getSurveyInfo.rejected, (state, action) => {
      state.loading = false;
      state.data = [];
      state.error = action.error.message;
    });
  },
});
export const { clearData, setLoading } = getSurveyInfoSlice.actions;
export default getSurveyInfoSlice.reducer;
